import { BUTTON_FONT } from 'components/landing/constants';
import discountTag from 'static/img/icons/discount_tag.svg';
import formatNumber from 'utils/format-number';
import Image from 'core/image';
import LandingSection from 'components/landing/components/landing-section';
import { PinkButton } from 'core/buttons/buttons';
import PropTypes from 'prop-types';
import { secureStringify } from 'utils/secure-json';
import SimpleTable from 'core/simple-table';
import Spacer from 'core/spacer';
import styles from 'styles/HowMuch.module.scss';
import Text from 'core/text';
import Title from 'core/title';
import useGetSeoTextByIndex from 'hooks/useGetSeoTextByIndex';
import { useMemo } from 'react';
import { useTranslations } from 'next-intl';

const HowMuch = ({ data }) => {
    const t = useTranslations('how-much');
    const { seoText, verification } = useGetSeoTextByIndex('how_much');

    if (!verification || !data) {
        return null;
    }

    function getPriceDisplay (price) {
        const priceSentence = t('table.price');
        return priceSentence.replace('[price]', formatNumber(price));
    }

    const tableHeaderList = useMemo(() => [
        t('table-header.coverage-type'),
        t('table-header.average-price')
    ], []);

    const tableData = useMemo(
        () => data.map((row) => [row.type, getPriceDisplay(row.value)]),
        [secureStringify(data)]);

    return (
        <LandingSection>
            <Title content={seoText.section_title} />
            <Text content={seoText.paragraph1.sentence1} />
            <Text content={seoText.paragraph2.sentence1} />
            <Text content={seoText.paragraph3.sentence1} marginBottom="40px"/>
            <div className={styles.container}>
                <div className={styles.container_item}>
                    <SimpleTable
                        headerList={tableHeaderList}
                        data={tableData}
                    />
                </div>
                <div className={styles.container_item}>
                    <Image className={styles.image} src={discountTag} alt={t('image')} width={100} />
                    <Spacer />
                    <PinkButton
                        label={`${t('button.label')} &#10095;`}
                        href={t('button.href')}
                        propsButton={BUTTON_FONT}
                    />
                </div>
            </div>
        </LandingSection>
    );
};

HowMuch.propTypes = {
    data: PropTypes.arrayOf(
        PropTypes.shape({
            type: PropTypes.string.isRequired,
            value: PropTypes.string.isRequired
        })
    ).isRequired
};

export default HowMuch;
